module.exports = __webpack_public_path__ + "static/img/3DPPT_LOGO_normal.d1a6441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3DPPT_LOGO_normal.png
// module id = eEBr
// module chunks = 13